/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import SellInvoiceTabUploadXmlViewComponent from './view';

import DebtorCompany from 'models/companies/debtorCompany';
import LeadOffer from 'models/leads/leadOffer';
import SellInvoiceTabUploadXmlForm from './model';

import CompanyService from 'services/CompanyService';
import CompanyLookupService from 'services/CompanyLookupService';
import { handleApiFormResponse } from 'lib/forms';
import NotificationHelper from 'lib/notifications';
import InvoiceDraft from 'models/invoices/seller/invoiceDraft';
import InvoiceSellerService from 'services/InvoiceSellerService';

type SellInvoiceTabUploadXmlComponentProps = {
  activeCompanyId: number;
  activeCompanyCountryId: number;
  leadOffer: LeadOffer;
  successHandler: (debtorCompany: DebtorCompany) => void;
  changeToPdfFlow: () => void;
}

type SellInvoiceTabUploadXmlComponentState = {
  form: SellInvoiceTabUploadXmlForm;
  formErrors: string[];
  isProcessing: boolean;
  invoiceDraft: InvoiceDraft;
  showUploadButton: boolean;
  filename: string;
}

class SellInvoiceTabUploadXmlComponent extends React.Component<SellInvoiceTabUploadXmlComponentProps, SellInvoiceTabUploadXmlComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      form: new SellInvoiceTabUploadXmlForm(),
      formErrors: [],
      invoiceDraft: null,
      isProcessing: false
    };
  }

  handleBooleanChange = (fieldName: string) => (event) => {
    const form = this.state.form;
    form[fieldName] = event.target.value === 'true';
    this.setState({ form });
  };


  handleDocumentSelect = (file: File) => {
    const form = this.state.form;
    form.file = file;
    this.setState({ form, filename: file.filename, formErrors: [], showUploadButton: false, invoiceDraft: null });
  };

  handleDocumentRemove = () => {
    const form = this.state.form;
    form.file = null;
    this.setState({ form, filename: null });
  };

  checkFile = async () => {
    if (this.state.form.file === null || !this.state.form.deliveredGoods) return;
    this.setState({ formErrors: [], isProcessing: true });

    try {
      const invoiceDraft = await InvoiceSellerService.readXml(this.state.form.file);
      this.setState({ invoiceDraft, isProcessing: false, showUploadButton: true });
    } catch (e) {
      handleApiFormResponse.call(this, e);
      this.setState({ isProcessing: false, showUploadButton: false, invoiceDraft: null });
    }
  }

  cancelFile = () => {
    const form = this.state.form;
    form.file = null;
    this.setState({ form, invoiceDraft: null, showUploadButton: false });
  };

  uploadFile = async () => {
    if (this.state.form.file === null) return;
    this.setState({ formErrors: [], isProcessing: true });

    let debtorCompanyId = this.state.invoiceDraft.debtorCompany.id;

    try {
      const debtorCompany = await CompanyLookupService.getDebtorSupplierCompany(this.props.activeCompanyId, debtorCompanyId);
      if (debtorCompany.isInsurable) {
        const result = await InvoiceSellerService.importXml(this.state.form.file);
        this.props.successHandler(debtorCompany, result.data);
      } else {
        this.setState({
          showUploadButton: false,
          formErrors: ['general.debtor.notInsurable'],
          isProcessing: false,
          invoiceDraft: null
        });
      }
    } catch (e) {
      handleApiFormResponse.call(this, e);
      this.setState({ isProcessing: false, showUploadButton: false, invoiceDraft: null });
    }
  }

  render() {
    return (
      <SellInvoiceTabUploadXmlViewComponent
        form={this.state.form}
        formErrors={this.state.formErrors}
        isProcessing={this.state.isProcessing}
        invoiceDraft={this.state.invoiceDraft}
        filename={this.filename}
        handleBooleanChange={this.handleBooleanChange}
        handleDocumentSelect={this.handleDocumentSelect}
        handleDocumentRemove={this.handleDocumentRemove}
        checkFile={this.checkFile}
        cancelFile={this.cancelFile}
        uploadFile={this.uploadFile}
        showChangeFlow={true}
        changeToPdfFlow={this.props.changeToPdfFlow}
        showUploadButton={this.state.showUploadButton}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id,
  activeCompanyCountryId: state.auth.user.activeCompany.countryId
});

export default connect(mapStateToProps)(SellInvoiceTabUploadXmlComponent);